import React from 'react'

const Slide6 = () => {
  return (
    <div>
        <p>
        1~3の数字を全て選択するとまた選択することができるようになります。
        </p>
    </div>
  )
}

export default Slide6